import { useCallback, useEffect, useState } from 'react';
import { useMerchantInfo } from './use-merchant-info';
import { useFormFeedback } from '@tectonics/components/form/hooks/use-form-feedback';

const LOCAL_VALIDATION_ERROR_IDS: readonly string[] = ['empty', 'invalid-pattern'];

function useCardSecurityCodeAlert(): { visible: boolean, dismiss: () => void } {
  const { isDemoMerchant } = useMerchantInfo();
  const { formHasBeenSent, validationError } = useFormFeedback('cardSecurityCode');

  const [hasBeenRejectedByProcessor, setHasBeenRejectedByProcessor] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const rejectedByProcessor = Boolean(
    formHasBeenSent &&
    validationError &&
    !LOCAL_VALIDATION_ERROR_IDS.includes(validationError.id)
  );

  useEffect(() => {
    if (rejectedByProcessor) setHasBeenRejectedByProcessor(true);
  }, [rejectedByProcessor]);

  const dismiss = useCallback((): void => setDismissed(true), []);
  const visible = isDemoMerchant && hasBeenRejectedByProcessor && !dismissed;

  return { visible, dismiss };
}

export { useCardSecurityCodeAlert };
